import { useRef, useState } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const CHECKOUT_URL = process.env.REACT_APP_CHECKOUT_URL;

const BookMockup = () => {
  const sceneRef = useRef(null);
  const [tilt, setTilt] = useState({ x: -8, y: 18 });
  const { scrollYProgress } = useScroll({ target: sceneRef, offset: ["start start", "end start"] });
  const rotateY = useTransform(scrollYProgress, [0, 1], [18, -14]);
  const y = useTransform(scrollYProgress, [0, 1], [0, 120]);

  const handleMove = (e) => {
    const rect = sceneRef.current.getBoundingClientRect();
    const px = (e.clientX - rect.left) / rect.width - 0.5;
    const py = (e.clientY - rect.top) / rect.height - 0.5;
    setTilt({ x: -8 - py * 12, y: 18 + px * 16 });
  };

  return (
    <motion.div
      ref={sceneRef}
      data-testid="hero-3d-book-canvas"
      className="book-scene relative flex items-center justify-center py-10"
      onMouseMove={handleMove}
      onMouseLeave={() => setTilt({ x: -8, y: 18 })}
      style={{ y }}
      initial={{ opacity: 0, scale: 0.85 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 1.2, delay: 0.9, ease: [0.16, 1, 0.3, 1] }}
    >
      <div className="absolute inset-0 -z-10 rounded-full bg-[radial-gradient(circle_at_center,rgba(212,175,55,0.18),transparent_65%)] blur-2xl" />
      <motion.div
        className="book-body relative h-[420px] w-[300px] sm:h-[480px] sm:w-[340px]"
        animate={{ y: [0, -14, 0] }}
        transition={{ duration: 5.5, repeat: Infinity, ease: "easeInOut" }}
        style={{ rotateX: tilt.x, rotateY }}
      >
        <div
          className="book-face absolute inset-0 flex flex-col justify-between overflow-hidden border border-[rgba(212,175,55,0.4)] bg-[#0d0d0d] p-8 shadow-[0_50px_100px_-20px_rgba(0,0,0,0.9)]"
          style={{ transform: "translateZ(22px)" }}
        >
          <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_30%_10%,rgba(212,175,55,0.14),transparent_55%)]" />
          <div>
            <p className="font-mono-label text-[10px] uppercase tracking-[0.35em] text-[#D4AF37]">Guia Prático</p>
            <div className="mt-4 h-px w-12 bg-[#D4AF37]" />
            <h3 className="font-serif-display mt-6 text-3xl font-bold leading-tight text-white sm:text-4xl">
              Social Media
              <br />
              <span className="italic text-[#D4AF37]">na Prática</span>
            </h3>
          </div>
          <div>
            <p className="font-mono-label text-[10px] uppercase tracking-[0.3em] text-[#A1A1AA]">
              Do zero ao primeiro cliente,
              <br />
              sem complicação
            </p>
            <div className="mt-6 h-px w-full bg-[rgba(212,175,55,0.3)]" />
            <p className="font-mono-label mt-4 text-[9px] uppercase tracking-[0.3em] text-[#71717A]">Método passo a passo</p>
          </div>
        </div>
        <div
          className="absolute left-0 top-0 h-full w-[44px] origin-left bg-gradient-to-r from-[#6b5416] via-[#C9A227] to-[#0d0d0d]"
          style={{ transform: "rotateY(-90deg) translateX(-22px)" }}
        />
        <div
          className="absolute right-0 top-[6px] h-[calc(100%-12px)] w-[44px] origin-right bg-[repeating-linear-gradient(to_right,#e8e0c8_0px,#e8e0c8_2px,#cfc6a8_3px,#cfc6a8_4px)]"
          style={{ transform: "rotateY(90deg) translateX(22px)" }}
        />
        <div className="absolute inset-0 translate-z-[-22px] bg-black" />
      </motion.div>
      <motion.div
        className="absolute -bottom-8 h-8 w-64 rounded-[50%] bg-black/80 blur-xl"
        animate={{ scaleX: [1, 0.9, 1], opacity: [0.8, 0.5, 0.8] }}
        transition={{ duration: 5.5, repeat: Infinity, ease: "easeInOut" }}
      />
    </motion.div>
  );
};

export default BookMockup;
